import { mapArchivedWorkflowResponse } from './helpers';
import { http } from '~helpers';

export default ({ namespace }) => {
  const requests = {
    fetchArchivalRecords: null,
  };

  return {
    fetchArchivalRecords: async query => {
      if (requests.fetchArchivalRecords) {
        requests.fetchArchivalRecords.abort();
      }

      const controller = new window.AbortController();
      const { signal } = controller;

      requests.fetchArchivalRecords = controller;

      const response = await http(
        window.fetch,
        `/api/namespaces/${namespace}/workflows/archived`,
        { query, signal }
      );

      const mappedResponse = mapArchivedWorkflowResponse(response);

      requests.fetchArchivalRecords = null;

      return mappedResponse;
    },
  };
};



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/workflow-archival-service.js